<template>
  <div class="loading-container">
    <loading
      :active="active"
      :is-full-page="isFullPage"
      :color="color"
      :background-color="backgroundColor"
      :opacity="opacity"
    >
      <template v-slot:before>
        <slot name="before"></slot>
      </template>
      <div class="loading-content">
        <slot></slot>
        <span v-if="!$slots.default">{{ message }}</span>
      </div>
      <template v-slot:after>
        <slot name="after"></slot>
      </template>
    </loading>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'LoadingOverlay',
  components: {
    Loading,
  },
  props: {
    active: {
      type: Boolean,
      default: true,
    },
    isFullPage: {
      type: Boolean,
      default: true,
    },
    message: {
      type: String,
      default: 'Loading...',
    },
    color: {
      type: String,
      default: '#4CAF50',
    },
    backgroundColor: {
      type: String,
      default: 'white',
    },
    opacity: {
      type: Number,
      default: 0.8,
    },
  },
}
</script>

<style scoped>
.loading-container {
  display: inline-block;
}
.loading-content {
  text-align: center;
  font-weight: bold;
  color: #4caf50;
  margin-top: 1rem;
}
</style>
